module.exports = __webpack_public_path__ + "img/tuto3.76e49c48.png";